import React from 'react';

import { RegionSwitcherSelector } from '@amzn/d16-g-adsp-region-switcher-ui';
import { useRegionSwitcherContext } from './RegionSwitcherProvider';
import { MarketplaceSwitcherProps } from 'src/features/header/components/MarketplaceSwitcher/MarketplaceSwitcher';
import { formatLocale } from 'src/providers/PantherLocalizationProvider/mbm';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { useRegionSwitcherUrlUpdater } from 'src/commons/utils/linkUpdater';

const RegionSwitcher: React.VFC<MarketplaceSwitcherProps> = () => {
  const { accounts, currentAccount } = useRegionSwitcherContext();

  const urlUpdater = useRegionSwitcherUrlUpdater();

  const handleSelect = (selected) => {
    if (selected?.url) {
      const redirectUrl = new URL(`https://${selected.url}`);
      urlUpdater?.(redirectUrl);
      window.location.assign(redirectUrl.toString());
    }
  };

  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  if (
    !accounts ||
    !currentAccount ||
    (Array.isArray(accounts) && accounts.length == 0)
  ) {
    return null;
  }
  return (
    <RegionSwitcherSelector
      id="aac-chrome"
      currentAccount={currentAccount}
      accounts={accounts}
      language={formatLocale(internalChromeConfig.locale)}
      onSelect={handleSelect}
    />
  );
};

export default RegionSwitcher;
